{
  "columns": [
    {
      "header_id": "tasBillingReconFileMasterId",
      "header_label": "Recon File Id",
      "jsonpath": "tasBillingReconFileMasterId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "eventCode",
      "header_label": "Event Code",
      "jsonpath": "eventCode",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "eventDatetime",
      "header_label": "Event DateTime",
      "jsonpath": "eventDatetime",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "rawResponseMsg",
      "header_label": "Response",
      "jsonpath": "rawResponseMsg",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "pplIcn",
      "header_label": "PPL ICN",
      "jsonpath": "pplIcn",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "waystarPayerId",
      "header_label": "Waystar Payer ID",
      "jsonpath": "waystarPayerId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "waystarRefD9",
      "header_label": "Waystar ICN",
      "jsonpath": "waystarRefD9",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "clientRefD9",
      "header_label": "Payer ICN",
      "jsonpath": "clientRefD9",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "createddate",
      "header_label": "Created Date",
      "jsonpath": "createddate",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    }
  ],
  "buttons": [],
  "apiDetails": "cdr.json",
  "pageName": "billingCdrFileDetailView",
  "orderByColumn": [
    "createddate"
  ],
  "orderBy": [
    "desc"
  ]
}